import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
export default class BolillaDetailedVotesModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);
    this.match = this.attrs.match;
    this.votes = this.match.bolillaVotes() || [];

    // Sort votes: if match is scored, sort by points descending.
    // Otherwise, sort by creation date descending (newest votes first).
    const isScored = this.match.scoreAthletic() !== null && this.match.scoreOpponent() !== null;
    this.votes.sort((a, b) => {
      if (isScored) {
        const pointsA = a.points() || 0;
        const pointsB = b.points() || 0;
        if (pointsB !== pointsA) {
          return pointsB - pointsA;
        }
      }
      // Fallback or default sorting by creation date descending
      const dateA = a.createdAt() ? new Date(a.createdAt()) : 0;
      const dateB = b.createdAt() ? new Date(b.createdAt()) : 0;
      return dateB - dateA;
    });
  }
  onready() {
    super.onready();
    // Reset scroll position to the very top so no voters are cut off or scrolled down
    const modalManager = document.querySelector('.ModalManager');
    if (modalManager) {
      modalManager.scrollTop = 0;
    }
    const modal = document.querySelector('.BolillaDetailedVotesModal');
    if (modal) {
      modal.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }
  className() {
    return 'BolillaDetailedVotesModal';
  }
  title() {
    return "Votos de La Bolilla: ".concat(this.match.getName());
  }
  content() {
    const isScored = this.match.scoreAthletic() !== null && this.match.scoreOpponent() !== null;
    return m("div", {
      className: "Modal-body"
    }, this.votes.length > 0 ? m("div", {
      className: "Bolilla-Votes-List"
    }, this.votes.map(vote => {
      const user = vote.user();
      if (!user) return null;
      const displayName = user.displayName() || user.username() || 'Usuario Desconocido';
      const avatarUrl = user.avatarUrl();
      const votedScore = vote.votedScore();
      const votedKnockout = vote.votedKnockoutWinner();
      const points = vote.points() || 0;
      return m("div", {
        className: "Bolilla-Vote-Card",
        key: vote.id()
      }, m("div", {
        className: "Voter-Info"
      }, avatarUrl ? m("img", {
        src: avatarUrl,
        className: "Voter-Avatar",
        alt: ""
      }) : m("div", {
        className: "Voter-Avatar-Placeholder"
      }, displayName.substring(0, 1).toUpperCase()), m("span", {
        className: "Voter-Name"
      }, displayName)), m("div", {
        className: "Voter-Prediction"
      }, m("span", {
        className: "Prediction-Badge"
      }, votedScore), votedKnockout && m("span", {
        className: "Prediction-Badge knockout"
      }, "Pasa: ", votedKnockout === 'Athletic' ? 'Athletic' : this.match.rival() ? this.match.rival().name() : this.match.opponent()), isScored && m("span", {
        className: "Points-Badge ".concat(points > 0 ? 'earned' : '')
      }, points, " ", points === 1 ? 'punto' : 'puntos')));
    })) : m("div", {
      style: "padding: 30px; text-align: center; color: #999; font-style: italic;"
    }, "No hay votos registrados para este partido."));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/bolilla/BolillaDetailedVotesModal', BolillaDetailedVotesModal);